<div class="offcanvas-header" #header>
  <h5 class="offcanvas-title">Product Search</h5>
  <button type="button" class="btn-close text-reset" aria-label="Close" (click)="dismiss()"></button>
</div>
<div class="offcanvas-body overflow-auto" style="max-height: 90vh">
  @if (products$ | async; as productsPaged) {
    <div class="row">
      @if (productsPaged.items.length > 0) {
        <div class="col-12 my-3">
          <sf-info-box color="light" text-color="dark">
            <p class="mb-0">
              Found {{ productsPaged.totalItemCount }} products based on your search, find your part below.
            </p>
          </sf-info-box>
        </div>
        <div class="col-12">
          <sf-label for="part" label="Parts Found"></sf-label>
          <div class="list-group">
            @for (part of productsPaged.items; track part) {
              <button
                type="button"
                class="list-group-item small list-group-item-action text-start"
                [class.active]="selectedPart && selectedPart.id === part.id"
                (click)="onPartSelect(part)"
                >
                <b>{{ part.description }}</b
                  ><br />
                  <div class="d-flex justify-content-between">
                    <span class="">MPN: {{ part.mpn }}</span
                      ><span class="">Cost: {{ part.cost | currency }}</span>
                    </div>
                  </button>
                }
              </div>
            </div>
            <div class="col-12">
              @if (productsPaged.totalItemCount > 0) {
                <ngb-pagination
                  class="d-flex justify-content-center mt-3"
                  [(page)]="productsPaged.pageNumber"
                  [pageSize]="productsPaged.pageSize"
                  [collectionSize]="productsPaged.totalItemCount"
                  [rotate]="true"
                  [ellipses]="false"
                  [maxSize]="4"
                  (pageChange)="onPageChange($event)"
                ></ngb-pagination>
              }
            </div>
            @if (selectedPart) {
              <div class="col-12 mt-3" #selectedPartElement>
                <sf-card>
                  <h5 class="card-title">{{ selectedPart.description }}</h5>
                  <p class="card-text">
                    <b>MPN:</b> {{ selectedPart.mpn }}<br />
                    <b>Cost:</b> {{ selectedPart.cost | currency }}<br />
                  </p>
                </sf-card>
                <div class="d-grid mt-3">
                  <button sfButton color="success" [disabled]="!selectedPart" (click)="confirmPart()">
                    Select Part
                  </button>
                </div>
              </div>
            }
          } @else {
            <sf-empty
              class="mt-2"
              message="There are no products to show, please change your search criteria"
            ></sf-empty>
          }
        </div>
      }
      <sf-info-box color="secondary" text-color="dark" class="mt-3"
        >Can't find your product? Add/amend products
        <a target="_blank" [routerLink]="['/admin', 'smartquote-bespoke-favourites']">here</a>.</sf-info-box
        >
        <hr />
        <div class="d-grid gap-2">
          <button sfButton type="button" color="danger" size="lg" (click)="close()">Close</button>
        </div>
      </div>
